import React, { FC } from "react";

import { formatDateTime } from "~/libs";

import { useProvidersCurrentEmployee } from "~/hooks";

import { MyRoutes } from "~/config/Paths";

import { SidebarLink } from "./SidebarLink";

import {
  ApiMembersUnreadNotificationCountsType,
  NavigationItemCompanyType,
} from "~/domains";

const today = formatDateTime(new Date(), "yyyy-MM-dd");

type NavConfig = {
  href: string;
};

type NavItem = {
  label: string;
  href: string;
};

type PropsType = {
  breadCrumbText: string;
  unreadNotification?: ApiMembersUnreadNotificationCountsType;
  navigationItems?: NavigationItemCompanyType[];
};

export const MemberSidebar: FC<PropsType> = ({
  breadCrumbText,
  unreadNotification,
  navigationItems,
}: PropsType) => {
  const { currentEmployee } = useProvidersCurrentEmployee();
  const defaultBusinessSectionId =
    currentEmployee?.businessSections[0]?.id || "";

  const navigationConfig: Record<string, NavConfig> = {
    メモログ: { href: MyRoutes.Members.insightPostsIndex() },
    チェックアウト: {
      href: MyRoutes.Members.inputEmployeeSurveysIndex({
        q: { business_section_id: defaultBusinessSectionId },
      }),
    },
    コンディション: {
      href: MyRoutes.Members.inputEmployeeConditionSurveysIndex({
        q: { business_section_id: defaultBusinessSectionId },
      }),
    },
    ナレッジシェア: {
      href: MyRoutes.Members.knowledgeInsightPostsFromTeamsIndex(),
    },
    本部の発信: {
      href: MyRoutes.Members.knowledgeInsightPostsFromManagersIndex({
        employeeRole: "owner",
      }),
    },
    部署の発信: {
      href: MyRoutes.Members.knowledgeInsightPostsFromManagersIndex({
        employeeRole: "manager",
      }),
    },
    ライブラリ: {
      href: `/document_file_category/owner?business_section_id=${defaultBusinessSectionId}`,
    },
    スキルマップ: {
      href: MyRoutes.Members.skillEvaluationStandardSummaryCategoriesIndex({
        q: { business_section_id: defaultBusinessSectionId },
      }),
    },
    ブログ: {
      href: `/sales_concept_category/owner?business_section_id=${defaultBusinessSectionId}`,
    },
    "Q&A": {
      href: `/question_answer_category/owner?business_section_id=${defaultBusinessSectionId}`,
    },
    "1on1・MTG": { href: MyRoutes.Members.meetingNotesNew() },
    "KPI・KGI": {
      href: `/kpi_daily_performances/${today}?business_section_id=${defaultBusinessSectionId}`,
    },
    ロールプレイング: { href: MyRoutes.Members.roleplayingConditionsNew() },
    "改善・相談": { href: MyRoutes.Members.kaizenIdeasIndex() },
    キャンパス: { href: MyRoutes.Members.privatePersonalMemosIndex() },
  };

  const displayNavs = navigationItems
    ?.filter((item) => item.role === "member" && !item.hiddenAt)
    .sort((a, b) => a.position - b.position);

  const navs: NavItem[] =
    displayNavs?.map((nav) => {
      const navConfig = navigationConfig[nav.name];
      return navConfig
        ? { label: nav.name, href: navConfig.href }
        : { label: "", href: "" };
    }) || [];

  return (
    <>
      {navs.map((nav) => (
        <SidebarLink
          key={nav.label}
          label={nav.label}
          href={nav.href}
          breadCrumbText={breadCrumbText}
          unreadNotification={unreadNotification}
        />
      ))}
    </>
  );
};
